<section class="u-page-section">
	<div class="u-container">
		<div class="c-help-bar">
			<a [routerLink]="['/', 'help']" class="c-btn-link u-text--uppercase u-text--medium">Heb je hulp nodig?</a>

			<a [routerLink]="['/']">
				<span class="u-text--medium u-text--xlight">Aanvraag afsluiten</span>

				<button class="c-btn-round u-m-left--xxs" title="Sluiten" type="button">
					<span class="icon-close"></span>
				</button>
			</a>
		</div>

		<h1 class="u-heading--xl-bold u-m-bottom--sm">Aanvraag van een {{ subsidyText }}</h1>

		<main *ngIf="user$ | async as user" class="u-content center">
			<span class="icon-checkmark-circle"></span>

			<h1 class="u-heading--xl-bold u-m-bottom--md">Bedankt {{ user.contact.person.firstName }}</h1>

			<p class="u-m-bottom--sm">
				Uw aanvraag van een <span class="u-text--bold">{{ subsidyText }}</span> wordt doorgestuurd naar ons dossiersysteem.
			</p>

			<p class="u-m-bottom--md u-width--md u-text--center">
				U ontvangt weldra een bevestigingsmail.<br/>Indien je na 2 werkdagen geen bevestigingsmail ontvangen hebt, neem dan contact op via <a [href]="'mailto:' + email">{{ email }}</a>.
			</p>

			<a [routerLink]="['/']" class="c-btn no-link">Sluiten</a>
		</main>
	</div>
</section>
